<template>
  <a :href="`${URL}${text.split(' ').join('+')}`" target="_blank" class="w-full underline truncate" @click.stop>
    <t-text :class="textClass" color="unset" :size="textSize">{{ text }}</t-text>
  </a>
</template>

<script>
  export default {
    name: 't-location',
    props: {
      text: {
        type: String,
        required: true
      },
      URL: {
        type: String,
        required: false,
        default: 'https://www.google.com/maps/search/?api=1&query='
      },
      textClass: {
        type: String,
        required: false,
        default: ''
      },
      textSize: {
        type: String,
        required: false,
        default: 'sm'
      }
    }
  }
</script>
